<template>
  <div class="wrapper" v-if="appointment">
    <div class="reschedule content">
      <h1>{{messages.rescheduleButtonText}}</h1>
      <div class="info-text">{{messages.selectDateTimeContentText}}</div>
      <time-selection
        v-if="appointmentServices.length > 0"
        :custom-slot-length="appointment.customSlotLength"
        :selected-services="appointmentServices"
        :selected-branch="appointment.branch"
        :service-is-array="true"
        :reschedule="true"
        @time-selected="newTimeSelected"
        ref="timeSelectionRef"
        tabindex="0"
      ></time-selection>
      <div v-if="mobileVerificationEnabled">
        <div class="updated-info">
          <div class="reschedule-row">
            <div class="reschedule-label">{{messages.commonDateAndTimeText}}:</div>
            <div class="reschedule-info">{{selectedDate | formatDate(selectedLanguage)}} {{selectedTime | formatTime(selectedLanguage)}}</div>
          </div>
        </div>
        <div class="other-info">
          <!-- GP-2942 removed the display of the old booking id, as it wasn't available
              when using url with public id.
          <div class="reschedule-row">
            <div class="reschedule-label">{{messages.commonBookingNumberText}}:</div>
            <div class="reschedule-info">{{appointment.externalId}}</div>
          </div>-->
          <div class="reschedule-row">
            <div class="reschedule-label" v-if="appointmentServices.length === 1">{{messages.commonServiceText}}:</div>
            <div class="reschedule-label" v-else>{{messages.commonMultipleServicesText}}:</div>

            <div class="reschedule-info">
             <!-- <span v-for="(service, index) in appointmentServices" :key="index"
                >{{service.adult? service.name + ': ' + service.adult + ' ' + messages.chooseServiceContentAdults + ', ' + service.child + ' ' + messages.chooseServiceContentChildren : service.name}}
              </span>-->

              <div v-for="(service, index) in appointmentServices" :key="index">
               {{ servicesTranslations[service.publicId] && servicesTranslations[service.publicId].names && servicesTranslations[service.publicId].names[selectedLanguage.lang] ? servicesTranslations[service.publicId].names[selectedLanguage.lang] : service.name }}
              <span v-if="configuration.multiplePeopleEnabled && (service.adult || service.child)">
                 (<span v-if="service.adult">{{service.adult}} <span v-if="service.adult == 1">{{messages.commonAdultText}}</span><span v-else>{{messages.commonAdultsText}}</span></span>
                <span v-if="service.adult && service.child">,</span>
                <span v-if="service.child">{{service.child}} <span v-if="service.child == 1">{{messages.commonChildText}}</span><span v-else>{{messages.commonChildrenText}}</span></span>)
              </span>
            </div>

            </div>
          </div>
          <div class="reschedule-row">
            <div class="reschedule-label">{{messages.commonLocationText}}:</div>
            <div class="reschedule-info">{{appointment.branchName}}</div>
          </div>
          <div class="reschedule-row" v-if="appointment.customer.email">
            <div class="reschedule-label">{{messages.Email}}:</div>
            <div class="reschedule-info">{{appointment.customer.email}}</div>
          </div>
          <div class="reschedule-row" v-if="appointment.customer.phone">
            <div class="reschedule-label">{{messages.Phone}}:</div>
            <div class="reschedule-info"> +{{appointment.customer.phone}}</div>
          </div>
          <div class="reschedule-row" v-if="checkShowPricesAndServicePrice">
            <div class="reschedule-label">{{messages.totalCost}}:</div>
            <div class="reschedule-info">{{appointment.totalCost}} {{messages.chooseServiceContentCurrency}}</div>
          </div>
          <div class="reschedule-row" v-if="checkShowPricesAndCondPrice">
             <div class="reschedule-label">{{messages.totalCost}}:</div>
             <div class="reschedule-info">{{condTotalCost}} {{messages.chooseServiceContentCurrency}}</div>
          </div>
        </div>
        <div class="fields-wrapper">
          <phone-field
            v-if="configuration.sendConfirm"
            @phone-verified="reschedulePhoneVerified"
            :field="field"
            :read-only="true"
            :show-autocomplete="false"
            :show-appointments="false"
            @is-phone-valid="setPhoneValidity"
          ></phone-field>
          <v-alert role="alert" :value="rescheduleError" type="error">{{rescheduleErrorMessage}}</v-alert>
          <vue-recaptcha
            v-if="configuration.captchaEnabled"
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            size="invisible"
            :sitekey="configuration.captchaSiteKey"
          ></vue-recaptcha>
          <v-btn
            ref="reschedulebtn"
            :ripple="false"
            text
            class="submit"
            @click="onReschedule"
            :disabled="status==='submitting' || (!phoneIsVerified && configuration.sendConfirm) || !isPhoneValid || !selectedDate || !selectedTime"
            id="rescheduleButton"
          >
            <div v-if="!status">{{messages.rescheduleButtonText}}</div>
            <v-progress-circular role="progressbar" indeterminate class="progress-bar" v-else></v-progress-circular>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RestService from '../services/restService'
import TimeSelection from '../components/TimeSelection'
import PhoneField from '../components/PhoneField'
import VueRecaptcha from 'vue-recaptcha'

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'RescheduleAppointment',
  props: [
    'configuration',
    'appointment',
    'startPage',
    'urlParams',
    'queryParams'
  ],
  mixins: [RestService],
  components: {
    TimeSelection,
    PhoneField,
    VueRecaptcha
  },
  data: () => ({
    customSlotLength: 0,
    mobileVerificationEnabled: false,
    phoneIsVerified: false,
    status: '',
    selectedTime: '',
    appointmentServices: [],
    selectedDate: '',
    field: {
      name: 'Phone',
      number: ''
    },
    recaptchaVerified: false,
    rescheduleError: false,
    rescheduleErrorMessage: null,
    isPhoneValid: true
  }),
  computed: {
    ...mapState([
      'messages',
      'selectedLanguage',
      'condTotalCost',
      'servicesTranslations',
      'branchTranslations'
    ]),
    checkShowPricesAndCondPrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'conditionalPrice'
    },
    checkShowPricesAndServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'servicesPrice'
    },
    checkServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.priceCalc === 'conditionalPrice'
    },
    ...mapGetters({
      getSecurityToken: 'getSecurityToken'
    })
  },
  methods: {
    ...mapActions([
      'checkBranchValidity',
      'setSelectedBranch',
      'setSelectedServices',
      'checkServicesValidity',
      'setCondTotalCost',
      'resetSelectedDateAndTimeSlot',
      'setAppMode'
    ]),
    ...mapMutations([
      'setServicesTranslations',
      'setBranchTranslations'
    ]),
    setPhoneValidity (validity) {
      this.isPhoneValid = validity
    },
    newTimeSelected (time, date) {
      var _this = this
      this.selectedTime = time
      this.selectedDate = date
      // get the new cost from backend if conditional prices
      if (this.checkServicePrice) {
        this.getConditionalPrice(date, time).then(response => {
          if (response.data.cost) {
            _this.setCondTotalCost(response.data.cost)
          }
          _this.newTimeSelectedSecondStep()
        })
      } else {
        this.newTimeSelectedSecondStep()
      }
    },
    newTimeSelectedSecondStep () {
      var _this = this
      if (this.configuration.sendConfirm) {
      } else {
        this.$nextTick(() => {
          if ('reschedulebtn' in _this.$refs) {
            _this.$refs.reschedulebtn.$el.focus()
          }
        })
      }
      this.mobileVerificationEnabled = true
    },
    reschedulePhoneVerified (verified) {
      if (verified) {
        this.phoneIsVerified = true
        this.setNextFocus()
      }
    },
    setNextFocus () {
      // set focus after phone verification
      this.$nextTick(() => {
        this.$refs.reschedulebtn.$el.focus()
      })
    },
    onReschedule () {
      var _this = this
      this.status = 'submitting'
      if (this.configuration.captchaEnabled && !this.recaptchaVerified) {
        this.$refs.recaptcha.execute()
      } else {
        this.rescheduleAppointment(
          this.appointment,
          false,
          this.selectedTime,
          this.selectedDate,
          this.getSecurityToken
        ).then(response => {
          switch (response.data.errorMessage) {
            case 'ERROR_TOO_LATE_TO_RESCHEDULE':
              _this.rescheduleError = true
              _this.status = ''
              _this.rescheduleErrorMessage = _this.messages.errorTooLateToReschedule
              break
            case 'ERROR_EXPIRED':
              _this.rescheduleError = true
              _this.status = ''
              _this.rescheduleErrorMessage = _this.messages.errorReservedExpired
              break
            case 'ERROR_SESSION_VIOLATION':
              _this.rescheduleError = true
              _this.status = ''
              _this.rescheduleErrorMessage = _this.messages.errorSessionViolation
              break
            case 'ERROR_GENERIC':
              _this.rescheduleError = true
              _this.status = ''
              _this.rescheduleErrorMessage = _this.messages.errorGenericConfirm
              break
            default:
              if (response.data.totalCost) {
                _this.setCondTotalCost(response.data.totalCost)
              }
              _this.$router.push({
                name: 'confirmation',
                params: {
                  confirmation: response.data,
                  startPage: 'booking'
                }
              })
              break
          }
        })
      }
    },
    onCaptchaVerified (token) {
      var _this = this
      this.recaptchaVerified = true
      this.rescheduleAppointment(
        this.appointment,
        token,
        this.selectedTime,
        this.selectedDate,
        this.getSecurityToken
      ).then(response => {
        if (response.data.totalCost) {
          _this.setCondTotalCost(response.data.totalCost)
        }
        _this.$router.push({
          name: 'confirmation',
          params: {
            confirmation: response.data
          }
        })
      })
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    // Set focus to first interactive element
    setfocus (data) {
      if (this.$route.name === 'reschedule') {
        this.$nextTick(() => { this.$refs.timeSelectionRef.$el.focus() })
      }
    }
  },
  mounted () {
    var _this = this
    _this.setAppMode('Reschedule')
    var tempServicesTranslations = {}
    var tempbranchTranslations = {}
    if (!this.appointment) {
      _this.$router.push({
        name: 'appointment',
        params: {
          appointmentId: _this.$route.params.appointmentId
        }
      })
    } else {
      this.setSelectedBranch(this.appointment.branch)
      this.checkBranchValidity()

      // set branch translations based on selected appointment branch
      if (typeof this.appointment.branch !== 'undefined' && this.appointment.branch) {
        tempbranchTranslations[this.appointment.branch.id] = {}
        tempbranchTranslations[this.appointment.branch.id].names = this.appointment.branch.custom.names
        this.setBranchTranslations(tempbranchTranslations)
      }

      this.field.number = this.appointment.customer.phone
      if (this.appointment.peopleServices.length > 0 && this.appointment.peopleServices[0].name) {
        this.appointmentServices = this.appointment.peopleServices
      } else {
        // This is an appointment not created in QWB
        this.appointmentServices = this.appointment.services
        for (var i = 0; i < this.appointmentServices.length; i++) {
          this.appointmentServices[i].adult = 1
        }
      }
      // Query all services to determine the customSlotLength for the selected services
      this.getServices().then(response => {
        if (this.funcDebug) console.log('RescheduleAppointment:mounted:getServices.then')
        var allServices = response.data
        this.appointmentServices.forEach(appService => {
          allServices.forEach(service => {
            if (parseInt(appService.qpId) === parseInt(service.qpId) || appService.internalId === parseInt(service.qpId)) {
              appService.customLength = service.duration
              tempServicesTranslations[service.publicId] = {}
              if (service.custom) {
                service.custom = JSON.parse(service.custom)
                tempServicesTranslations[service.publicId].names = service.custom.names
              } else {
                tempServicesTranslations[service.publicId].names = {}
              }
            }
          })
        })
        this.setServicesTranslations(tempServicesTranslations)
        this.setSelectedServices(this.appointmentServices)
        this.checkServicesValidity()
        this.resetSelectedDateAndTimeSlot()
      })
    }
  },
  created () {
    // Event Bus: receive route name to set focus to first interactive element
    eventHub.$on('focusFirstEvent', (payload) => { this.setfocus(payload) })
  }
}
</script>

<style lang="scss">
.reschedule .v-input.input-field.v-text-field.phone-input {
  width: 324px;
  margin-left: 0;
  padding-top: 0px !important;
  position: relative;

  @at-root [dir="rtl"] & {
    margin-left: auto;
    margin-right: 24px;
  }
}

.reschedule .input-field .v-input__slot:before {
  border-width: 1px;
  border-color: var(--input-border-color) !important;
}

.reschedule .v-input.input-field.v-text-field {
  padding: 16px 0 0 0;
  width: 550px;
}

.reschedule .v-input.input-field.v-text-field .v-label {
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  height: 22px;
  padding-left: 12px;
}

.reschedule .input-field.v-text-field {
  padding-left: 12px;
}

.reschedule .input-field .v-input__slot {
  border-top: 1px solid var(--input-border-color) !important;
  border-right: 1px solid var(--input-border-color) !important;
  border-left: 1px solid var(--input-border-color) !important;
  height: 48px;
}

.reschedule .fields-wrapper {
  position: relative;
}

.reschedule .fields-wrapper .phone-verification-btn.v-btn {
  position: absolute;
  left: 330px;
  height: 56px;
  background-color: var(--primary-btn-bg-color) !important;
  font-weight: 400;
  color: var(--primary-bg-text-color) !important;
  top: 0;
  margin: 0 0 0 48px;

  @at-root [dir="rtl"] & {
    left: auto;
    right: 330px;
  }
}

.reschedule .v-input--selection-controls.v-input .v-label {
  font-weight: 700;
  color: var(--default-font-color) !important;
}

.reschedule .submit.v-btn.v-btn--disabled.v-btn--text.theme--light {
  background-color: var(--primary-btn-bg-disabled-color);
}

.reschedule .submit.v-btn.v-btn--text.theme--light {
  margin: 24px;
}

.reschedule .updated-info {
  border-top: 1px solid var(--input-border-color) !important;
  font-weight: 500;
  font-size: 18px;
  padding: 24px 24px 0 24px;
}

.reschedule .other-info {
  padding: 0 24px 24px 24px;
}

.reschedule-label{
  font-weight: bolder;
  width: 30%;
  float: left;
}
.reschedule-info{
  float: left;
  width: 70%;
}
.reschedule-row{
  overflow: auto;
}

.reschedule .timeslot {
  width:92px;
}

@media screen and (width: 768px) {
  .reschedule .timeslot {
    width: 88px;
  }
  .reschedule .timeslot-content.v-btn-toggle .v-btn:focus {
    width: 88px !important;
  }
}

@media only screen and (max-width: 450px) {
  .reschedule-label, .reschedule-info{
    width: 100% !important;
  }
}

@media (max-width: 600px) {
  .reschedule .v-input.input-field.v-text-field.phone-input {
    width: 100%;
    @at-root [dir="rtl"] & {
      margin-right: 0;
    }
  }

  .reschedule .v-input.input-field.v-text-field {
    padding: 16px 16px 0 16px;
  }

  .reschedule .updated-info {
    border-top: 1px solid var(--input-border-color) !important;
    font-weight: 500;
    padding: 16px 16px 0 16px;
  }

  .reschedule .other-info {
    padding: 0 16px 16px 16px;
  }

  .reschedule .fields-wrapper .phone-verification-btn.v-btn {
    position: static;
    left: auto;
    margin-left: 16px;

    @at-root [dir="rtl"] & {
      right: auto;
      margin-left: 0;
      margin-right: 16px;
    }
  }

  .reschedule .submit.v-btn.v-btn--text.theme--light {
    display: block;
    margin: 16px;
  }
}
</style>
